module.exports = __webpack_public_path__ + "static/img/14bg_7.700f1cd.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/background/14bg_7.png
// module id = 658
// module chunks = 1